import { forwardRef, type Ref, type SVGProps } from "react";
const IconYardSignFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M29 6H8V2.93a1 1 0 0 0-2 0V6H2.89a1 1 0 0 0 0 2H6v21.06A1 1 0 0 0 7 30a1 1 0 0 0 1-.93V8h4v2h2V8h10v2h2V8h3a1 1 0 0 0 0-2" /><rect width={18} height={13} x={10} y={10} fill="currentColor" rx={2} /></svg>;
const ForwardRef = forwardRef(IconYardSignFilledSVG);
ForwardRef.displayName = "IconYardSignFilled";
export { ForwardRef as IconYardSignFilled };